/**
 * Копирование / вставка выделенных узлов: Ctrl|Meta+C / Ctrl|Meta+V.
 * Не перехватывает ввод в полях форм (input, textarea, contenteditable).
 */

function isTypingTarget(el) {
	if (!el || typeof el !== 'object') return false;
	const tag = (el.tagName && String(el.tagName).toLowerCase()) || '';
	if (tag === 'input' || tag === 'textarea' || tag === 'select') return true;
	return Boolean(el.isContentEditable);
}

export default {
	init(modeler, context) {
		const {graph} = context;
		const container = graph?.container;
		const listenerTarget =
			typeof document !== 'undefined' &&
			document &&
			typeof document.addEventListener === 'function'
				? document
				: container;
		if (!listenerTarget || typeof listenerTarget.addEventListener !== 'function') {
			return () => {};
		}

		let lastClientPoint = null;
		const onPointerMove = e => {
			if (!e) return;
			const x = e.clientX;
			const y = e.clientY;
			if (typeof x === 'number' && typeof y === 'number') {
				lastClientPoint = {x, y};
			}
		};
		// Keep it lightweight: only the latest mouse position for "copy under cursor" fallback.
		listenerTarget.addEventListener('pointermove', onPointerMove, true);
		// Чтобы Ctrl+C работал сразу после клика по node (без обязательного pointermove),
		// фиксируем координаты на pointerdown.
		listenerTarget.addEventListener('pointerdown', onPointerMove, true);

		const getLocalPoint = (clientX, clientY) => {
			const cx = clientX ?? 0;
			const cy = clientY ?? 0;
			const p =
				typeof graph.clientToLocal === 'function'
					? graph.clientToLocal(cx, cy)
					: graph.coord?.clientToLocalPoint?.(cx, cy);
			if (p == null) return {x: 0, y: 0};
			return {x: Number(p.x) || 0, y: Number(p.y) || 0};
		};

		const getNodeUnderPoint = point => {
			const nodes = graph.getNodes?.() ?? [];
			for (const node of nodes) {
				const bbox = node.getBBox?.();
				if (!bbox) continue;
				const w = bbox.width ?? 0;
				const h = bbox.height ?? 0;
				if (
					point.x >= bbox.x &&
					point.x <= bbox.x + w &&
					point.y >= bbox.y &&
					point.y <= bbox.y + h
				) {
					return node;
				}
			}
			return null;
		};

		const onKeyDown = e => {
			if (!e || isTypingTarget(e.target)) return;
			const mod = e.ctrlKey || e.metaKey;
			if (!mod) return;
			const key = (e.key || '').toLowerCase();
			if (key === 'c') {
				const ok = modeler.copyBoardSelection?.();
				if (ok) {
					e.preventDefault();
					e.stopPropagation();
					return;
				}
				// Fallback: if nothing selected, copy node under cursor.
				if (lastClientPoint && graph?.getNodes?.length !== undefined) {
					try {
						const local = getLocalPoint(lastClientPoint.x, lastClientPoint.y);
						const node = getNodeUnderPoint(local);
						if (node?.id) {
							const ok2 = modeler.copyBoardSelection?.({anchorCellId: node.id});
							if (ok2) {
								e.preventDefault();
								e.stopPropagation();
							}
						}
					} catch (_) {}
				}
			} else if (key === 'v') {
				let anchorPoint;
				if (lastClientPoint) {
					try {
						anchorPoint = getLocalPoint(lastClientPoint.x, lastClientPoint.y);
					} catch (_) {}
				}
				const r = modeler.pasteBoardSelection?.(anchorPoint ? {anchorPoint} : undefined);
				if (r?.ok) {
					e.preventDefault();
					e.stopPropagation();
				}
			}
		};

		listenerTarget.addEventListener('keydown', onKeyDown, true);
		return () => {
			listenerTarget.removeEventListener('pointermove', onPointerMove, true);
			listenerTarget.removeEventListener('pointerdown', onPointerMove, true);
			listenerTarget.removeEventListener('keydown', onKeyDown, true);
		};
	},
};
